import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import Ptdc from "../utility/ptdc";
import ProductAttribute from "../utility/product-attribute";
import ProductAccordion from "../utility/product-accordion";
import ProductDetail from "../utility/product-detail";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";

const CollectionDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const collection = location.state?.collection;

  // Se non abbiamo i dati della collezione, torniamo alla lista
  if (!collection) {
    navigate("/collections");
    return null;
  }

  return (
    <>
      <div className="single-product container-cust mx-auto">
        <div className="back-button">
          <button onClick={() => navigate("/collections")}>
            <ChevronLeftIcon className="mr-2" />
          </button>

          <button
            onClick={() => navigate("/collections")}
            className="cta cta-standard"
          >
            terre del sud
          </button>
        </div>
        <div className="grid grid-cols-12 gap-4 header">
          <div className="col-span-12 outer-container">
            <div className="text-container">
              <div className="details-container">
                <div className="detail">ID:</div>
                <div className="detail">
                  {collection.blockchainData?.totalSupply || "0"}/
                  {collection.blockchainData?.maxSupply || "N/A"}
                </div>
              </div>
              <Ptdc
                // pretitle={"Tipologia: " + productData.type.value}
                title={collection.name}
                description={collection.description}
                size="medium"
              />
            </div>
            <div className="img-container">
              <img
                src={collection.image}
                alt={collection.name}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 attributes-section">
          <div className="col-span-12">
            <h3>Attributi</h3>
          </div>
          {collection.metadata?.attributes?.length > 0 && (
            <>
              {collection.metadata.attributes.map((attr, idx) => (
                <div
                  key={`${attr.trait_type}-${idx}`}
                  className="col-span-12 sm:col-span-6 lg:col-span-4"
                >
                  <ProductAttribute
                    label={attr.trait_type}
                    value={attr.value}
                  />
                </div>
              ))}
            </>
          )}
        </div>

        <hr className="my-16" />

        <div className="grid grid-cols-12 gap-4 autentication">
          <div className="col-span-12">
            {collection.metadata?.authentication && (
              <ProductAccordion title="Autenticazione">
                <div className="outer-product-details-container">
                  <div className="macro-details">
                    <div className="macro-details-subsection">
                      {/* <h5>Authentication</h5> */}
                      <div className="product-details grid grid-cols-12 gap-4">
                        <div className="col-span-12 sm:col-span-6 lg:col-span-4">
                          <ProductDetail
                            label="Manufacture Date"
                            value={
                              collection.metadata.authentication.manufactureDate
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ProductAccordion>
            )}

            {collection.metadata?.productionPhases &&
              Object.keys(collection.metadata.productionPhases).length > 0 && (
                <ProductAccordion title="Production Phases">
                  {Object.entries(collection.metadata.productionPhases).map(
                    ([phase, data], idx) => (
                      <div
                        key={idx}
                        className="outer-product-details-container"
                      >
                        <h4>{phase}</h4>
                        <div className="macro-details">
                          <div key={idx} className="macro-details-subsection">
                            <h5>{phase}</h5>
                            <div className="product-details grid grid-cols-12 gap-4">
                              {Object.entries(data).map(([key, value]) => (
                                <div
                                  key={key}
                                  className="col-span-12 sm:col-span-6 lg:col-span-4"
                                >
                                  <ProductDetail label={key} value={value} />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                </ProductAccordion>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CollectionDetail;
